<div class="tooltip">
    <img class="inline mr-2" width="9" src="../../../../assets/img/ic-info.svg" alt="">
    <span class="tooltiptext">{{tooltipTitle}}</span>
</div>